<template>
	<div class="page-header">
		<h1 class = "title-header">TaskSchedule with VueX<small> - Crafted by Vuong </small> 
			<img
			v-if = "!backgroundColor"
			@click = "changeColor" src = "/nightday.svg" width="3%">

			<img 
			v-else
			@click = "changeColor" src = "/day.svg" width="3%"></h1>
		<hr class="my-4">
	</div>
</template>
<script type="text/javascript">
	export default{
		name: "component-title",

		props: {
			backgroundColor: {type: Boolean, default: false}
		},
		data: function(){
			return {

			}
		},

		methods: {
			changeColor: function(){
				this.$emit("changeColorApp");
			}
		}
	}
</script>
<style type="text/css">
	.title-header{
		font-family: Inter,-system-ui,system-ui,sans-serif;
	    color: #010101;
	    margin: .5em 0 .3em;
	    -webkit-font-smoothing: antialiased;
	    font-size: 39px;
	    letter-spacing: -.05em;
	    font-weight: 700;
	    line-height: 1.1;
	    display: inline-block;
	}

</style>